import { render, staticRenderFns } from "./remitinfo.vue?vue&type=template&id=90987f0e"
import script from "./remitinfo.vue?vue&type=script&lang=js"
export * from "./remitinfo.vue?vue&type=script&lang=js"
import style0 from "./remitinfo.vue?vue&type=style&index=0&id=90987f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports